import { LoadingOverlay, Pagination, Box, Flex, Title, Text, Button, Center } from '@mantine/core';
import { useWindowScroll, useDisclosure } from '@mantine/hooks';
// import { IconSortDescending } from '@tabler/icons-react';

import { CustomTableMobileItem } from './custom-table-mobile-item';

import styles from './custom-table-mobile.module.css';

import type { TTableMobileRow } from './custom-table-mobile-item';

type Props = {
  rows: TTableMobileRow[];
  tableTitle?: string;
  headerPointsCount?: number;
  isLoading?: boolean;
  isPaginated?: boolean;
  itemsCount?: number;
  pageSize?: number;
  currentPage?: number;
  onPageChange?: (page: number) => void;
  children?: React.ReactElement;
};

export const CustomTableMobile = (props: Props) => {
  const {
    rows,
    tableTitle,
    headerPointsCount = 1,
    isLoading,
    isPaginated = true,
    itemsCount = 1,
    pageSize = 30,
    currentPage,
    onPageChange,
  } = props;

  const pageCount = Math.ceil(itemsCount / pageSize);

  const [allOpened, { toggle }] = useDisclosure(false);
  const [, scrollTo] = useWindowScroll();
  const handlePageChange = (page: number) => {
    onPageChange?.(page);
    scrollTo({ y: 0 });
  };

  return (
    <Box mb={'xl'}>
      {tableTitle && (
        <Title order={5}>{tableTitle}</Title>
      )}

      <LoadingOverlay
        visible={isLoading}
        overlayProps={{ blur: 2 }}
      />

      {!isLoading && (rows.length > 0) && (
        <Box className={styles['btns']} mb={5}>
          {/* <Button
          className={styles['toggle-btn']}
          size="compact-sm"
          variant="default"
          onClick={toggle}
        >
          <IconSortDescending
            size={16}
            stroke={1.5}
            style={{
              transform: allOpened ? 'rotate(-180deg)' : 'rotate(0deg)',
              transition: 'transform 200ms ease',
            }}
          />
        </Button> */}
          <Button
            className={styles['toggle-btn']}
            size="compact-sm"
            variant="default"
            fullWidth
            onClick={toggle}
          >
            {allOpened ? 'Свернуть все карточки' : 'Раскрыть все карточки'}
          </Button>
        </Box>
      )}

      <div className={styles['custom-table-mobile']}>
        {rows.map((row) => (
          <CustomTableMobileItem
            key={row.key}
            row={row}
            headerPointsCount={headerPointsCount}
            isOpen={allOpened}
          />
        ))}
      </div>

      {!isLoading && (rows.length === 0) && (
        <Center>
          <Text size='sm'>Нет данных</Text>
        </Center>
      )}

      {isPaginated && (rows.length > 0) && (
        <Flex justify="center" mt="md">
          <Pagination
            value={currentPage}
            onChange={(page: number) => handlePageChange(page)}
            total={pageCount}
          />
        </Flex>
      )}
    </Box>
  );
};
